import i18n from "../../../i18n";

const appendRequestId = (message: string, requestId?: string | null) =>
  requestId ? `${message}\n ${i18n.t("COMMON.ERROR_CODE")} : ${requestId}` : message;

export const handleApiError = (
  data,
  setWarningMessage,
  setShowWarningMessage,
  setErrorMessage,
  setShowErrorMessage
) => {
  let message = JSON.parse(data.data.message);
  if (message.length >= 1) {
    let messageShow = message[0].Value.DefaultMessage;
    messageShow = appendRequestId(messageShow, data.data.requestId);
    // warning
    if (data.data.returnType === 2) {
      setWarningMessage(messageShow);
      setShowWarningMessage(true);
    }
    // error
    else if (data.data.returnType === 3) {
      setErrorMessage(messageShow);
      setShowErrorMessage(true);
    }
  } else {
    let messageShow = message.Value.DefaultMessage;
    messageShow = appendRequestId(messageShow, data.data.requestId);
    // warning
    if (data.data.returnType === 2) {
      setWarningMessage(messageShow);
      setShowWarningMessage(true);
    }
    // error
    else if (data.data.returnType === 3) {
      setErrorMessage(messageShow);
      setShowErrorMessage(true);
    }
  }
};

export const handleFullApiError = (
  data,
  setWarningMessage,
  setShowWarningMessage,
  setErrorMessage,
  setShowErrorMessage,
  message
) => {
  if (data.data?.isSuccess == false) {
    let message = JSON.parse(data.data.message);
    if (message.length >= 1) {
      let messageShow = message[0].Value.DefaultMessage;
      messageShow = appendRequestId(messageShow, data.data.requestId);
      // warning
      if (data.data.returnType === 2) {
        setWarningMessage(messageShow);
        setShowWarningMessage(true);
      }
      // error
      else if (data.data.returnType === 3) {
        setErrorMessage(messageShow);
        setShowErrorMessage(true);
      }
    } else {
      let messageShow = message.Value.DefaultMessage;
      messageShow = appendRequestId(messageShow, data.data.requestId);
      // warning
      if (data.data.returnType === 2) {
        setWarningMessage(messageShow);
        setShowWarningMessage(true);
      }
      // error
      else if (data.data.returnType === 3) {
        setErrorMessage(messageShow);
        setShowErrorMessage(true);
      }
    }
  } else {
    if (data?.response?.data == "Access Denied !") {
      setErrorMessage(i18n.t("COMMON.ACCESS_DENIED"));
      setShowErrorMessage(true);
    } else {
      setErrorMessage(`${message} : \n ${data}`);
      setShowErrorMessage(true);
    }
  }
};

export const handleApiErrorForContactToProducerCenter = (
  data,
  setWarningMessage,
  setShowWarningMessage
) => {
  let message = JSON.parse(data.data.data[0].failedMessage);

  let messageShow = message.Value.DefaultMessage;
  setWarningMessage(messageShow);
  setShowWarningMessage(true);
};
